import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export enum MobileType {
  IOS,
  ANDROID,
  MOBILE_WEB,
}

export type MobileState = {
  isMobile: boolean;
  type?: MobileType;
};

export const MobileStore = signalStore(
  { providedIn: 'root' },
  withState<MobileState>({
    isMobile: false,
    type: undefined,
  }),
  withMethods(store => ({
    setMobileType(type: MobileType): void {
      patchState(store, { type: type });
    },
    setMobile(isMobile: boolean): void {
      patchState(store, { isMobile: isMobile });
    },
  })),
);
